/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Kn_EmptyInputs */

const cs_property_registry_kn_empty = /** @type {(inputs: Property_Registry_Kn_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro tento kód RÚIAN se budova v katastru nenašla.`)
};

const en_property_registry_kn_empty = /** @type {(inputs: Property_Registry_Kn_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No cadastre building found for this RÚIAN code.`)
};

/**
* | output |
* | --- |
* | "No cadastre building found for this RÚIAN code." |
*
* @param {Property_Registry_Kn_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_kn_empty = /** @type {((inputs?: Property_Registry_Kn_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Kn_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_kn_empty(inputs)
	return cs_property_registry_kn_empty(inputs)
});